module.exports = __webpack_public_path__ + "img/search.e84cf089.png";